export default "__VITE_ASSET__DZbhD3jP__"